import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import { FC } from 'react'
import { useGetList, useRecordContext, useTranslate } from 'react-admin'
import RequestStatusChip from '../../components/cards/ActieverzoekStatusChip'
import { Actieverzoek, Deelnemer, Samenwerking } from '../../types/apiRequests'

const PartnersPanel: FC = () => {
  const translate = useTranslate()
  const record = useRecordContext<Samenwerking>()

  const { data: partners, isLoading: loadingPartners, error: errorPartners } = useGetList<Deelnemer>(
    `deelnemers/${record?.id}`,
    {
      filter: {},
      pagination: { page: 1, perPage: 10 },
    }
  )

  const { data: requests, isLoading: loadingRequests, error: errorRequests } = useGetList<Actieverzoek>(
    `actieverzoeken/${record?.id}`,
    {
      filter: { samenwerkingId: record?.id },
      pagination: { page: 1, perPage: 100 },
    }
  )

  if (loadingPartners || loadingRequests) return <div />
  if (errorPartners || errorRequests) {
    return (
      <Typography color="error">
        {translate('ra.notification.http_error')}
      </Typography>
    )
  }

  return (
    <List disablePadding>
      {partners?.map((partner) => {
        const partnerRequests = requests?.filter(
          (req) => req.ontvangerNaam === partner.organisatie.naam
        ) || []

        return (
          <ListItem key={partner.organisatie.id} alignItems="flex-start">
            <Box sx={{ width: '100%' }}>
              <ListItemText primary={<span style={{ fontWeight: '700'}}>{partner.organisatie.naam}</span>} />
              {partnerRequests.length > 0 && (
                <Box sx={{ mt: 1 }}>
                  {partnerRequests.map((req) => (
                    <Box
                      key={req.actieverzoekId}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 0.5,
                      }}
                    >
                      <Typography variant="body1">{req.titel}</Typography>

                      <RequestStatusChip status={req.status} label={false} />
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          </ListItem>
        )
      })}
      {partners?.length === 0 && (
        <Typography variant="body2" color="textSecondary" sx={{ p: 1 }}>
          {translate('show.noPartners')}
        </Typography>
      )}
    </List>
  )
}

export default PartnersPanel
